import React from 'react';
import { Link } from "react-router-dom";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import ServiceHighlights from "../components/ServiceHighlights";
import ServicesOverview from "../components/ServicesOverview";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import PartnerMarquee from "../components/PartnerMarquee";
import HelpButton from "../components/HelpButton";
import ActivationSteps from "../components/ActivationSteps";
import { Phone } from "lucide-react";
import { Reviews } from "../components/Reviews";
import SEO from "../components/SEO";

function KookgroepAansluiten() {
  return (
    <div className="min-h-screen bg-white page-transition pt-[99px] md:pt-[133px]">
      <SEO
        title="Kookgroep aansluiten voor uw inductiekookplaat - elektricieninarnhem026.nl"
        description="Laat uw kookgroep vakkundig aansluiten door onze gecertificeerde elektriciens in Arnhem. Veilig en volgens de laatste normen."
        image="/images/banner.png"
      />
      <Header />
      <HeroSection
        title="Kookgroep aansluiten voor uw inductiekookplaat in Arnhem"
        description="Laat uw kookgroep vakkundig aansluiten door onze gecertificeerde elektriciens in Arnhem. Veilig en volgens de laatste normen."
        imageSrc="/images/perilexaan.png"
      />

      {/* Features Section */}
      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1088px] mb-12 md:mb-16">
        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Wat maakt een kookgroep noodzakelijk bij elektrisch koken in
              Arnhem?
            </h2>
            <p>
              Bij elektrisch koken, zoals met een inductiekookplaat, is het
              belangrijk om een aparte kookgroep te hebben. Deze kookgroep zorgt
              ervoor dat je kookplaat genoeg stroom krijgt zonder dat je
              elektrische installatie overbelast raakt. Onze gecertificeerde
              elektriciens in Arnhem zorgen voor een veilige installatie en
              controleren of je meterkast geschikt is voor de nieuwe kookgroep.
              Als dat nodig is, breiden we je meterkast uit zodat alles goed
              werkt.
            </p>

            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  Offerte aanvragen
                </span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#E6B800] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:-order-1">
            <div className="relative">
              <span className="absolute bg-[#E6B800] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
                elektricieninarnhem026.nl
              </span>

              <img
                alt="Kookgroep installatie"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/perilex-aansluiten-kookgroep-elektraaanleg.jpg"
              />
            </div>
          </div>
        </div>

        <ActivationSteps />

        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-1">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Hoe weet je of je meterkast geschikt is voor een kookgroep in
              Arnhem?
            </h2>
            <p>
              Om te weten of je meterkast geschikt is voor een kookgroep,
              controleer je of er genoeg ruimte is voor een extra groep en of je
              meterkast voldoende vermogen kan leveren voor je
              inductiekookplaat. Als je meterkast een verouderd systeem heeft of
              te weinig capaciteit, moet deze mogelijk worden uitgebreid. Onze
              gecertificeerde elektriciens in Arnhem kunnen de situatie
              eenvoudig beoordelen. Wij zorgen ervoor dat je meterkast wordt
              aangepast zodat alles veilig en volgens de normen werkt voor je
              nieuwe kookgroep.
            </p>

            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  Offerte aanvragen
                </span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#E6B800] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:order-2">
            <div className="relative">
              <span className="absolute bg-[#E6B800] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
                elektricieninarnhem026.nl
              </span>

              <img
                alt="Slim stroom handelen met thuisbatterij"
                loading="lazy"
                width="1028"
                height="1032"
                decoding="async"
                data-nimg="1"
                src="/images/perilex-kookplaat.png"
                srcSet="/images/perilex-kookplaat.png"
                style={{ color: "transparent" }}
              />
            </div>
          </div>
        </div>

        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              1 fase of 3 fase aansluiting in Arnhem
            </h2>
            <p>
              Een 1 fase aansluiting is geschikt voor standaard kookplaten, maar
              een inductiekookplaat heeft meestal een 3 fase aansluiting nodig
              voor meer vermogen en een betere verdeling van de stroom. Onze
              elektriciens in Arnhem helpen je bij het kiezen van de juiste
              aansluiting en passen je meterkast indien nodig aan.
            </p>

            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  Offerte aanvragen
                </span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#E6B800] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:-order-1">
            <div className="relative">
              <span className="absolute bg-[#E6B800] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
                elektricieninarnhem026.nl
              </span>
              <img
                alt="Kookgroep installatie"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/perilex.png"
              />
            </div>
          </div>
        </div>
      </section>

      <ServicesOverview />

      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1088px] mb-12 md:mb-16">
        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="order-1 md:-order-1">
            <div className="relative">
              <span className="absolute bg-[#E6B800] text-white px-2 py-1 text-xs rounded-md opacity-20 top-1/4 right-1/3">
                elektricieninarnhem026.nl
              </span>
              <img
                alt="Inductiekoken voordelen"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/1200x674.jpg"
              />
            </div>
          </div>
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Wat zijn de voordelen van inductiekoken?
            </h2>
            <p>
              Inductiekoken biedt tal van voordelen ten opzichte van
              traditionele kookmethodes. Het is energiezuiniger, sneller en
              veiliger. In tegenstelling tot gas- of elektrische kookplaten
              verhit inductie alleen de pan, waardoor er minder energie verloren
              gaat. Dit resulteert in lagere energiekosten. Bovendien is
              inductiekoken veiliger omdat de kookplaat zelf niet heet wordt,
              waardoor het risico op brand of verbranding vermindert.
            </p>
          </div>
        </div>
      </section>

      <FAQ />

      <ServiceHighlights />
      <Reviews />
      <PartnerMarquee />

      {/* CTA Section */}
      <div className="w-full cursor-pointer bg-[#FFD100] transition-opacity duration-150 hover:opacity-80">
        <Link
          to="/offerte"
          aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
        >
          <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1088px] text-center py-6 justify-between items-center">
            <div
              data-variant="h2"
              className="font-bold leading-[1.25] text-[28px] lg:text-[36px] self-center text-white mb-0"
            >
              Offerte aanvragen
            </div>
          </section>
        </Link>
      </div>

      <HelpButton />
      <Footer />
    </div>
  );
}

export default KookgroepAansluiten;
